import { createModuleHttpClient } from '../../createModuleHttpClient';
import demoModule from '../index';

const client = createModuleHttpClient(demoModule.id);

export default client;
